<template>
  <div class="flex-col org-main"
    :class="{news: newsType==0 ,market:newsType==1 }">
    <transition name="slide-fade">
      <form v-show="showSearchBar"
        style="width:100%;display:flex;">
        <van-search v-model="searchValue"
          placeholder="请输入关键字进行搜索，如消费"
          style="flex: 1;"
          @clear="onSearch()"
          @search="onSearch()"
          @blur="changeSearch()" />
        <div :id="'overview-filter'+newsType"
          style="display: flex; align-items: center;margin-right: 10px;font-size: 14px;"
          @click="showSearch"
          class="sort-style">
          <span> {{ $t("common.filter") }} </span>
          <i class="iconfont iconfilter-outline "
            style="margin-left: 4px;font-size: 14px;"></i>
        </div>
        <van-popup v-model="showSearchPanel"
          position="right"
          :style="{ height: '100%', width: '80%' }">
          <search-panel :type="searchPanelType"
            @search="searchByPanel"></search-panel>
        </van-popup>

        <van-popup v-model="showSearchPanelNews"
          position="right"
          :style="{ height: '100%', width: '80%' }">
          <search-panel :type="searchPanelTypeNews"
            @search="searchByPanel"></search-panel>
        </van-popup>
      </form>
    </transition>
    <div class="split-info" />
    <div id="cont-list-news"
      class="cont-list"
      v-on:scroll.passive="handleScroll2"
      v-if="newsType==0">

      <van-list v-model="news.loading"
        :finished="news.finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="item in news.itemList"
          :key="item.id">
          <div class="flex-col item-info"
            @click="goNewsDetail(item.id)">

            <label class="news-title"
              v-html="item.newsTitle"></label>
            <div class="flex-row news-info">
              <label>{{ $t('newsFrom') }}{{item.domain}}</label>
              <label>{{ item.publishDate}}</label>
            </div>
          </div>
          <div class="split-info" />
        </div>
      </van-list>
    </div>
    <div :id="'cont-list-'+newsType"
      class="cont-list"
      v-on:scroll.passive="handleScroll2"
      v-if="newsType!=0">
      <van-list v-model="marketNews.loading"
        :finished="marketNews.finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="offset">
        <div v-for="item in marketNews.itemList"
          :key="item.id">
          <div class="flex-col item-info"
            @click="goNewsDetail(item.id)">
            <label class="news-title"
              v-html="item.newsTitle"></label>
            <div class="flex-row news-info">
              <label>{{item.industry}}</label>
              <label>{{ item.createTime}}</label>
            </div>
          </div>
          <div class="split-info" />
        </div>
      </van-list>
    </div>

    <!-- <div class="cont-list"
      v-if="newsType==2 || newsType==3">
      <van-list v-model="marketNews.loading"
        :finished="marketNews.finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="item in marketNews.itemList"
          :key="item.id">
          <div class="flex-row collect"
            @click="goNewsDetail(item.id)">
            <div class="flex-col item-info">
              <label class="news-title"
                v-html="item.newsTitle"></label>
              <div class="flex-row news-info">
                <label>{{ $t('newsFrom') }}{{item.newsFrom}}</label>
                <label>{{ item.createTime}}</label>
              </div>
            </div>
          </div>
          <div class="split-info" />
          <div v-if="refreshView"></div>
        </div>
      </van-list>
    </div> -->
  </div>
</template>

<script>
import common from "@common/common";
import webService from "@network/webService";
import SearchPanel from '@/components/common/SearchPanel.vue';
import scollerLocation from '@/common/scollerLocation';
export default {
  name: "",
  props: {
    newsType: {
      type: Number,
      default: 0,
    },
    relationId: {
      type: Number,
      default: 0
    }
  },
  components: {
    SearchPanel,
  },
  data () {
    return {
      showSearchBar: true,
      showSearchPanelNews: false,
      showSearchPanel: false,

      searchPanelTypeNews: common.searchTypeEnum.newsType,
      searchPanelType: common.searchTypeEnum.marketPeriod,
      searchValue: '',
      offset: 20,
      OrderType: 2,
      searchType: null,
      searchPeriod: 0,
      searchValue: "",
      news: {
        itemList: [],
        loading: false,
        finished: false,
        currentPage: 0,
      },
      marketNews: {
        itemList: [],
        loading: false,
        finished: false,
        currentPage: 0,
      },
      refreshView: false,
      lastLocation: 0,
    };
  },
  created () {
    console.log('newsType' + this.newsType);
    if (this.newsType != 0) {
      this.loadData(2);
    }
  },
  mounted () { },

  methods: {
    handleScroll2 () {
      let scrollTop = 0;
      if (this.newsType == 0) {
        scrollTop = document.getElementById('cont-list-news').scrollTop;
      } else {
        scrollTop = document.getElementById('cont-list-' + this.newsType).scrollTop;
      }
      if (scrollTop <= 1) {
        this.showSearchBar = true;
        return;
      }
      if (scrollTop > this.lastLocation) {
        console.log("向下");
        this.showSearchBar = false;
      } else {
        console.log("向上。。。");
        this.showSearchBar = true;
      }
      this.lastLocation = scrollTop;
      console.log(scrollTop);
    },
    loadData (type) {
      this.news.itemList = [];
      this.news.loading = false;
      this.news.currentPage = 0;
      this.marketNews.itemList = [];
      this.marketNews.loading = false;
      this.marketNews.currentPage = 0;
      this.OrderType = type;
      this.onLoad();
    },
    onLoad () {
      if (this.newsType == 0) {
        this.requestPageData(this.news, true);
      } else {
        this.requestPageData(this.marketNews, true);
      }
    },
    requestPageData (obj, isAdd) {

      var param = {
        PageSize: 20,
        Page: obj.currentPage,
        Search: this.searchValue,
        OrderType: this.OrderType,
        SearchType: this.searchType,
        SearchPeriod: this.searchPeriod,
      };
      obj.loading = true;
      if (this.newsType == 0) {
        webService.getNewsList(param).then((res) => {

          //搜索模块需要高亮
          if (
            !_.isEmpty(this.searchValue) &&
            this.searchValue.length > 0
          ) {
            this.hightLightNews(res.data, this.searchValue);
          }
          this.processData(obj, res.data, isAdd);
        });
      } else {
        param.relationTypeId = this.relationId;
        webService.getMargetNewsList(param).then((res) => {
          //搜索模块需要高亮
          if (
            !_.isEmpty(this.searchValue) &&
            this.searchValue.length > 0
          ) {
            this.hightLightNews(res.data, this.searchValue);
          }
          this.processData(obj, res.data, isAdd);
        });
      }
    },
    processData (obj, data, isAdd) {
      data.forEach((e) => {
        if (e.publishDate) {
          e.publishDate = this.$moment(e.publishDate).format(
            "DD/MM/YYYY"
          );
        }
        if (e.createTime) {
          e.createTime = this.$moment(e.createTime).format(
            "DD/MM/YYYY"
          );
        }
        e.checked = false;
      });
      if (isAdd) {
        for (let i = 0; i < data.length; i++) {
          obj.itemList.push(data[i]);
        }
      } else {
        obj.itemList = data;
      }
      obj.loading = false;
      if (data.length <= 0) {
        obj.finished = true;
      }
      else {
        obj.finished = false;
      }
      obj.currentPage++;
    },
    goNewsDetail (id) {
      if (this.newsType == 0) {
        this.$router.push({
          path: "/newsDetail",
          query: {
            id: id,
            type: this.newsType,
          },
        });
      } else if (this.newsType == 2 || this.newsType == 3) {
        this.$router.push({
          path: "/newsMarket",
          query: {
            id: id,
          },
        });
      } else {
        this.$router.push({
          path: "/newsMarket",
          query: {
            id: id,
          },
        });
      }
    },
    searchData (searchParam) {

      if (
        searchParam.searchPeriod &&
        searchParam.searchPeriod.length > 0
      ) {
        this.searchPeriod = parseInt(searchParam.searchPeriod[0]);
      } else {
        this.searchPeriod = 0;
      }

      if (this.newsType == 0) {
        this.searchType = searchParam.newsTypeString;
        // this.searchPeriod = 0;
        this.news.currentPage = 0;
        this.requestPageData(this.news, false);
      } else {
        this.searchType = null;

        this.marketNews.currentPage = 0;
        this.requestPageData(this.marketNews, false);
      }
    },

    changeSearch () {
      this.changeSearchValue(this.searchValue);
    },
    onSearch () {
      if (this.newsType == 0) {
        this.searchNews(this.searchValue);
      } else {
        this.searchMarket(this.searchValue);
      }
    },
    searchNews (searchValue) {
      this.searchValue = searchValue;
      this.news.currentPage = 0;
      this.requestPageData(this.news, false);
    },
    searchMarket (searchValue) {

      this.searchValue = searchValue;
      this.marketNews.currentPage = 0;
      this.requestPageData(this.marketNews, false);
    },
    hightLightNews (marketList, search) {
      if (
        marketList.length > 0 &&
        !_.isEmpty(search) &&
        search.length > 0
      ) {
        let searchArray = _.split(search, " ");
        searchArray.forEach((e) => {
          let searchItem = e;
          let replaceReg = new RegExp(searchItem, "g"); // 匹配关键字正则
          let replaceString =
            '<span style="color:#c52a1a">' + searchItem + "</span>"; // 高亮替换v-html值
          marketList.forEach((e) => {
            //e.newsTitle = this.$options.filters['ellipsis'](e.newsTitle, 80);
            e.newsTitle = e.newsTitle.replace(
              replaceReg,
              replaceString
            ); // 开始替换
          });
        });
      }
    },
    selectAll () {
      this.marketNews.itemList.forEach((element) => {
        element.checked = true;
      });
      this.refreshView = !this.refreshView;
    },
    cancelSelected () {
      this.marketNews.itemList.forEach((element) => {
        element.checked = false;
      });
      this.refreshView = !this.refreshView;
    },
    deleteItem () {
      console.log(this.marketNews)
      common.batchDeleteMarked_News(this.marketNews);
    },
    cancelMark (id) {
      common.cancelMark(this.marketNews.itemList, id);
    },
    changeSearchValue (value) {
      this.searchValue = value;
    },

    showSearch () {
      if (this.newsType == 0) {
        this.showSearchPanelNews = true;
      } else {
        this.showSearchPanel = true;
      }
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        debugger;
        document.getElementById('overview-filter' + this.newsType).classList.add('has-filter');

      } else {
        document.getElementById('overview-filter' + this.newsType).classList.remove('has-filter');
      }

      this.searchData(searchParams);
      this.showSearchPanelNews = false;
      this.showSearchPanel = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.org-main {
  border-top: 1px solid #dedede;
  height: 100%;
  // height: calc(100% - 110px);
}
.news {
  // height: calc(100% - 110px);
}
.market {
  // height: calc(100% - 110px);
}
.cont-list {
  height: 100%;
  overflow: auto;
  flex: 1;
}
.news-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 0.7rem;
  max-height: 40px;
  overflow: hidden;
}
.news-info {
  font-size: 12px;
  justify-content: space-between;
  color: #7d7d7d;
}
.collect {
  //width:80%;
  align-items: center;
  justify-content: space-between;
}
.split-info {
  height: 1px;
}
.item-info {
  padding: 0.6rem 1rem 0.5rem 1rem;
}

.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter
/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/overview/TabList.vue